import { createSlice } from "@reduxjs/toolkit";
import { Player } from "../Types";

export type DoublingCubeData = {
  owner: Player | null;
  gameStakes: number;
  enabled: boolean;
  playerOneHasDoubled?: boolean;
  playerTwoHasDoubled?: boolean;
};

export const InitialDoublingCubeState: DoublingCubeData = {
  owner: null,
  gameStakes: 1,
  enabled: true,
  playerOneHasDoubled: false,
  playerTwoHasDoubled: false,
};

export const doublingCubeSlice = createSlice({
  name: "doublingCubeState",
  initialState: InitialDoublingCubeState,
  reducers: {
    setDoublingCubeData: (
      state,
      action: { type: string; payload: DoublingCubeData }
    ) => {
      return {
        ...state,
        ...action.payload,
        // Preserve per-player doubled flags unless explicitly provided
        playerOneHasDoubled:
          action.payload.playerOneHasDoubled ?? state.playerOneHasDoubled ?? false,
        playerTwoHasDoubled:
          action.payload.playerTwoHasDoubled ?? state.playerTwoHasDoubled ?? false,
      };
    },
    resetDoublingCubeData: (state) => {
      return {
        ...InitialDoublingCubeState,
        enabled: state.enabled,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDoublingCubeData, resetDoublingCubeData } =
  doublingCubeSlice.actions;

export default doublingCubeSlice.reducer;
